import { MeetingSnapshot } from "../../domain/api/meetings/MeetingSnapshot";
import { MeetingSnapshotSentiment } from "../../domain/api/meetings/MeetingSnapshotSentiment";
import { PredefinedSnapshotType } from "../../domain/api/meetings/PredefinedSnapshotType";
import { MeetingSnapshotInfo } from "../../domain/site/MeetingSnapshotInfo";
import configStore from "../../stores/ConfigStore";

export default class MeetingSnapshotDataService {

    public static async takeSnapshotAsync(): Promise<MeetingSnapshotInfo> {
        const token = await configStore.getTokenAsync();
        return fetch(`${configStore.hosts.api}/snapshots`, {
            body: JSON.stringify({
                snapshotType: PredefinedSnapshotType.PERSONAL
            }),
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
            },
            method: "POST",
        })
        .then(e => e.json());
    }

    public static async updateSnapshotAsync(snapshot: MeetingSnapshot): Promise<MeetingSnapshotInfo> {
    
        const token = await configStore.getTokenAsync();
        return fetch(`${configStore.hosts.api}/snapshots`, {
            body: JSON.stringify(snapshot),
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
            },
            method: "PUT",
        })
        .then(e => e.json());
    }

    public static async getSnapshotsAsync(meetId: string): Promise<MeetingSnapshotInfo[]> {
        const token = await configStore.getTokenAsync();
        return fetch(`${configStore.hosts.api}/snapshots?code=${meetId}`, {
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
            },
            method: "GET",
        })
        .then(e => e.json());
    }

    public static async deleteSnapshotsAsync(snapshotId: string) {
        const token = await configStore.getTokenAsync();
        return fetch(`${configStore.hosts.api}/snapshots/${snapshotId}`, {
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
            },
            method: "DELETE",
        });
    }

    public static async recordSentimentAsync(snapshotId: string, sentiment: MeetingSnapshotSentiment): Promise<MeetingSnapshotInfo> {
        const token = await configStore.getTokenAsync();
        return fetch(`${configStore.hosts.api}/snapshots/${snapshotId}/sentiment`, {
            body: JSON.stringify(sentiment),
            headers: {
                "Authorization": `bearer ${token}`,
                "Content-Type": "application/json",
            },
            method: "POST",
        })
        .then(e => e.json());
    }

}

